import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { GenericRepository } from "src/app/repositories/generic-repository/GenericRepository";
import { Machines } from "src/app/models/Production/Machines";
import { IMachinesRepository } from "./IMachinesRepository";

@Injectable({
  providedIn: 'root'
})
export class MachinesRepository
  extends GenericRepository<Machines>
  implements IMachinesRepository {

  constructor(protected _http: HttpClient) {
    super(_http, 'api/machines', environment.urlAddress);
  }

  // SelectAll
  GetAll(
    currentPage: number,
    recordsPerPage: number,
    filterText: string
  ): Observable<any> {

    filterText = filterText.split('/').join('~');

    if (!filterText || filterText.trim() === "") {
      filterText = "";
    }

    return this.Get(
      'SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText
    );
  }

  // Save
  SaveRec(item: Machines): Observable<ResponseModel> {
    return this.PostData('/SaveRec', item)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  // Navigation
  LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
    const url = `/NavRec/${navType}/${currentIndex}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  // Get Single
  LoadRec(Id: number): Observable<ResponseModel> {
    const url = `/GetRec/${Id}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  // Delete
  DeleteRec(Id: number): Observable<ResponseModel> {
    const url = `/DeleteRec/${Id}`;
    return this.Delete(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  // Search
  Search(name: string): Observable<ResponseModel> {
    const url = `/Search/${name}`;
    return this.GetById(url)
      .pipe(map(this.extractData), catchError(this.handleError));
  }
}